import { dataExport } from 'ducks/entities/schema'

export const exportsNormalizationSchema = {
  exports: {
    nodes: [dataExport],
  },
}
